import MyApps from './MyApps'
import MoreApps from './MoreApps'
import type { VFC } from 'react'
import type { InstancesAndApps, Tsg, AppFilters } from '../../types'

const HubHome: VFC<InstancesAndApps & AppFilters & { tsg: Tsg }> = ({ instances, apps, tsg, appFilterFn, appAccessFilterFn }) => {
  return <>
    <MyApps instances={instances} apps={apps} tsg={tsg} appAccessFilterFn={appAccessFilterFn} />
    <MoreApps apps={apps} instances={instances} appFilterFn={appFilterFn} appAccessFilterFn={appAccessFilterFn} />
  </>
}

export default HubHome
